
import { observable, action } from "mobx"
import request from "app/vendor/request"
import config from "app/config"
import { message } from "antd"
import List from "app/stores/list"

export default class Store {
  @observable detailData = observable.map({})
  @observable orgList = []

  @action getOrgList = () => {
    return request.get(`${config.backend}/accounts/orgs`)
      .checkToken()
      .commonDispose()
      .then(res => {
        this.orgList = res
        return Promise.resolve(res)
      }, err => {
        message.error(err)
        return Promise.reject(err)
      })
  }

  @action createAccount = (data) => {
    return request.post(`${config.backend}/accounts/users`)
      .send(data)
      .checkToken()
      .commonDispose()
  }

  @action setDetailData = (data) => {
    this.detailData.merge(data)
  }

  @action updateAccount = () => {
    return request.put(`${config.backend}/accounts/users/${this.detailData.get('id')}`)
      .send(this.detailData.toJS())
      .checkToken()
      .commonDispose()
      .then(
        res => {
          this.detailData.clear()
          this.list.getTableData()
            .then(
              res => {
                this.list.updateTableData(res)
                this.list.initPageIndex()
              }
            )
          return Promise.resolve(res)
        },
        err => {
          message.error(err)
          return Promise.reject(err)
        }
      )
  }

  @action getAccountDetail = (userId) => {
    return request.get(`${config.backend}/accounts/users/${userId}`)
      .checkToken()
      .commonDispose()
      .then(
        res => {
          this.detailData = observable.map({ ...res })
        }
      )
  }

  @action toggleSwitch = (record) => {
    if (record.disable) {
      this.enable(record)
    } else {
      this.disable(record)
    }
  }

  @action setSwitchState = (record, state) => {
    record.disable = state
  }

  @action enable = (record) => {
    return request.put(`${config.backend}/accounts/users/${record.id}/enable`)
      .checkToken()
      .commonDispose()
      .then(
        res => {
          this.setSwitchState(record, false)
          message.success('启用成功')
        },
        err => {
          message.error(err)
        }
      )
  }

  @action disable = (record) => {
    return request.put(`${config.backend}/accounts/users/${record.id}/disable`)
      .checkToken()
      .commonDispose()
      .then(
        res => {
          this.setSwitchState(record, true)
          message.success('停用成功')
        },
        err => {
          message.error(err)
        }
      )
  }

  static fromJS() {
    const store = new Store()
    store.list = new List(store, "accounts/users")
    return store
  }
}


// WEBPACK FOOTER //
// ./src/app/stores/preview/bypass-account.js